import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "53",
  height: "53",
  viewBox: "0 0 53 53",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_54_336)" }, [
      _createElementVNode("path", { d: "M29.6136 26.5L39.1094 17.0263C39.5253 16.6104 39.7589 16.0464 39.7589 15.4583C39.7589 14.8703 39.5253 14.3063 39.1094 13.8904C38.6936 13.4746 38.1296 13.241 37.5415 13.241C36.9534 13.241 36.3895 13.4746 35.9736 13.8904L26.4999 23.3863L17.0261 13.8904C16.6103 13.4746 16.0463 13.241 15.4582 13.241C14.8701 13.241 14.3061 13.4746 13.8903 13.8904C13.4744 14.3063 13.2408 14.8703 13.2408 15.4583C13.2408 16.0464 13.4744 16.6104 13.8903 17.0263L23.3861 26.5L13.8903 35.9738C13.6833 36.179 13.519 36.4233 13.4069 36.6924C13.2948 36.9615 13.2371 37.2501 13.2371 37.5417C13.2371 37.8332 13.2948 38.1218 13.4069 38.3909C13.519 38.66 13.6833 38.9043 13.8903 39.1096C14.0956 39.3166 14.3398 39.4809 14.6089 39.593C14.878 39.7051 15.1667 39.7628 15.4582 39.7628C15.7497 39.7628 16.0384 39.7051 16.3075 39.593C16.5766 39.4809 16.8208 39.3166 17.0261 39.1096L26.4999 29.6138L35.9736 39.1096C36.1789 39.3166 36.4232 39.4809 36.6923 39.593C36.9614 39.7051 37.25 39.7628 37.5415 39.7628C37.8331 39.7628 38.1217 39.7051 38.3908 39.593C38.6599 39.4809 38.9042 39.3166 39.1094 39.1096C39.3164 38.9043 39.4807 38.66 39.5928 38.3909C39.7049 38.1218 39.7627 37.8332 39.7627 37.5417C39.7627 37.2501 39.7049 36.9615 39.5928 36.6924C39.4807 36.4233 39.3164 36.179 39.1094 35.9738L29.6136 26.5Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_54_336" }, [
        _createElementVNode("rect", {
          width: "53",
          height: "53"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }